module.exports = __webpack_public_path__ + "img/henry-fleet.53b9a1e4.png";